import { Component, HostListener } from '@angular/core';
import { Event as RouterEvent, NavigationEnd, ActivatedRoute, NavigationStart } from "@angular/router";
import { Router } from "@angular/router";
import { fromEvent, Observable, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { PubSubService } from './shared/services/pub-sub-service';
import { deleteCookie, getCookie, setCookie } from './shared/functions/coockie';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AppService } from './app.service';
import { updateUserProperty } from './shared/functions/others';
import { AccountsService } from './accounts/accounts.service';
import { BaseCalss } from './shared/classes/base-config.class';
import { LottoService } from './pages/lotto/lotto.service';

function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}

@Component({
  selector: 'app-root',
  styleUrls: ['./app.component.scss'],
  template: `
    <ng4-loading-spinner [timeout]="50000"></ng4-loading-spinner>
    <div [ngClass]="{'club-home': isHomePage}">
      <router-outlet></router-outlet>
    </div>
  `
})

export class AppComponent {

  title = 'smartlotto-public';
  currentRoute: string;
  navigationSubscription: any;
  isHomePage: boolean;

  onlineEvent: Observable<Event>;
  offlineEvent: Observable<Event>;
  subscriptions: Subscription[] = [];
  connectionStatusMessage: string;
  connectionStatus: string;

  public isShowingRouteLoadIndicator: boolean;

  deferredPrompt: any;
  showButton = false;

  @HostListener('window:beforeinstallprompt', ['$event'])
  onbeforeinstallprompt(e) {
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    e.preventDefault();
    // Stash the event so it can be triggered later.
    this.deferredPrompt = e;
    this.showButton = true;
  }

  constructor(
    // updates: SwUpdate,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    public _pubSubService: PubSubService,
    private appService: AppService,
    private spinnerService: Ng4LoadingSpinnerService,
    private accountService: AccountsService,
    private lottoService: LottoService,

  ) {
    this.route.queryParams.subscribe(params => {
      if (params['_rfclburl']) {
        setCookie('_rfclburl', params['_rfclburl'], 30);
      }
    });
    // updates.available.subscribe(event => {
    //   if (confirm('New version is available. Do you want to update?')) {
    //     document.location.reload();
    //   }
    // })

    this.checkInternetConnection();
    router.events.subscribe(e => {

      if (e instanceof NavigationStart) {
        spinnerService.show();
      }

      if (e instanceof NavigationEnd) {
        spinnerService.hide();
      }

      if (e instanceof NavigationStart) {
        if (!router.navigated) {
         // this.deleteGuestToken();
        }
      }

    });
  }


  ngOnInit() {
    this.removeOldToken();
    if (getCookie('storeData')) {
      const userData = JSON.parse(getCookie('storeData'));
      if (userData) {
        this.appService.storeData$.next(userData);
      }
    }

    const domain = this.accountService.getDomain;
    this.appService.balanceUpdate.subscribe(async () => {
      const totalBalance = await this.appService.totalBalance().toPromise();
      if (totalBalance && totalBalance.success) {
        updateUserProperty('total_balance', totalBalance.data.balance, domain);
        const updated = JSON.parse(getCookie('storeData'));

        this.appService.storeData$.next(updated);
      }
    });
    this.currentRoute = this.router.url;
    this.isClubHomePage();

    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        this.currentRoute = this.router.url;
        this.isClubHomePage();
      }
    });

    this._pubSubService.AddHomeStream.subscribe((e: any) => {
      if (e.add) {
        this.addToHome();
      }
    });

    this.appService.getIpAddress().subscribe((result: any) => {
        setCookie('cAdr', result.ip, 1);
      },
      error => {
        console.log('Error in getting error', error);
      }
    );

  }

  private removeOldToken() {
    const env = (new BaseCalss()).env;
    if (env === 'PROD') {
      deleteCookie('token', 'games.smartlotto.ie');
    } else if (env === 'TEST') {
      deleteCookie('token', 'games.esmartlotto.ie');
    }
  }


  addToHome() {
    this.showButton = false;
    this.deferredPrompt.prompt();
    this.deferredPrompt.userChoice
      .then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the A2HS prompt');
        } else {
          console.log('User dismissed the A2HS prompt');
        }
        this.deferredPrompt = null;
      });
  }


  checkInternetConnection() {
    if (!window.navigator.onLine) {
      this.toastr.error("Please, Enable your internet conection.", "OFFLINE");
    }
    this.onlineEvent = fromEvent(window, 'online');
    this.offlineEvent = fromEvent(window, 'offline');

    this.subscriptions.push(this.onlineEvent.subscribe(e => {
      this.connectionStatusMessage = 'Back to online';
      this.connectionStatus = 'online';
      console.log('Online...');
      this.toastr.success(this.connectionStatusMessage, 'Connected!');
    }));

    this.subscriptions.push(this.offlineEvent.subscribe(e => {
      this.connectionStatusMessage = 'Connection lost! You are not connected to internet';
      this.connectionStatus = 'offline';
      console.log('Offline...');
      this.toastr.error(this.connectionStatusMessage);
    }));

  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }


  isClubHomePage() {
    let routeSegments = this.currentRoute.split('/');
    this.isHomePage = routeSegments[1] == 'pages' && routeSegments[2] == 'club';
  }

  deleteGuestToken() {
    // if (getCookie('gstTkn') && getCookie('gstTkn') == 'true') {
    //   const domain = this.appService.getDomain;
    //   deleteCookie('token', domain);
    //   deleteCookie('gstTkn', domain);
    // }
  }

}
